import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getVoucherMasterBook = async (code) => {
  try {
    const resp = await apiWrapper(
      "GET",
      `voucher_tickets?voucher_ticket_code=${code}`
    );
    store.commit("ticketing/setMasterBook", resp.data[0].master_book);
    return resp.data[0];
  } catch (err) {
    console.log('ERROR"" getVoucherMasterBook()');
    throw err;
  }
};
